import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { DoorProxyForDealsSelection } from 'models/door_proxies_for_deals_selection'

export const SELECT_LOCATIONS = {
  name: {
    header: 'Name',
    group: 'Company Attributes',
  },
  address: {
    header: 'Address',
    group: 'Company Attributes',
  },
  city: {
    header: 'City',
    group: 'Company Attributes',
  },
  state: {
    header: 'State',
    group: 'Company Attributes',
  },
  zipcode: {
    header: 'ZIP Code',
    group: 'Company Attributes',
  },
  dma: {
    header: 'DMA',
    group: 'Company Attributes',
  },
  domain: {
    header: 'Domain',
    group: 'Company Attributes',
  },
  place_url: {
    header: 'Place URL',
    group: 'Company Attributes',
  },
} satisfies Partial<Record<keyof DoorProxyForDealsSelection, DataTypeColumn>>
